// @flow

// Misma alarma u orden: no repetir toast ni sonido por una reentrega del socket.
export const NOTIFICATION_DEDUPE_MS = 10000;

/**
 * In-session light dedupe: same key suppressed until TTL expires.
 * @param {number} ttlMs milliseconds to suppress duplicates (default 10s)
 * @returns {(key: string | number) => boolean} true when the event should present
 */
export function createTtlDedupe(ttlMs: number = NOTIFICATION_DEDUPE_MS) {
  const seen: Map<string | number, number> = new Map();

  return function shouldPresent(key: string | number): boolean {
    if (key === null || key === undefined || key === "") {
      return true;
    }
    const now = Date.now();
    seen.forEach((expiresAt, id) => {
      if (expiresAt <= now) {
        seen.delete(id);
      }
    });
    if (seen.has(key)) {
      return false;
    }
    seen.set(key, now + ttlMs);
    return true;
  };
}
